import { render, staticRenderFns } from "./EnrollPaymentTab.vue?vue&type=template&id=1129b4c0&scoped=true&"
import script from "./EnrollPaymentTab.vue?vue&type=script&lang=ts&"
export * from "./EnrollPaymentTab.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollPaymentTab.vue?vue&type=style&index=0&id=1129b4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1129b4c0",
  null
  
)

export default component.exports